<div class="form-group" attr.aria-describedby="{{ id }}-help">
  @if (header_text) {
    <div
      class="header-text normalize-external-styles"
      [innerHTML]="header_text | domSanitizer"
    ></div>
  }

  @if (label) {
    <label for="{{ id }}-{{ name }}" class="form-label" [ngClass]="{ required: required }">
      {{ label }}
    </label>
  }

  <div class="input-group">
    <input
      ngbDatepicker
      id="{{ id }}-{{ name }}"
      class="form-control"
      placeholder="MM/DD/YYYY"
      maxlength="10"
      restrict-input="date"
      #d="ngbDatepicker"
      [class.is-invalid]="control.errors && control.dirty"
      [name]="name"
      [formControl]="control"
      [required]="required"
      [minDate]="min_date"
      [maxDate]="max_date"
    />
    <button as-button class="btn form-element-btn z-0" (click)="d.toggle()" type="button">
      <span class="material-icons"> calendar_month </span>
    </button>
  </div>

  @if (control.dirty && control.errors) {
    <div id="{{ id }}-error" class="text-danger mt-2">
      @if (control.errors['required']) {
        <span>{{ 'input_is_required' | translate: label }}</span>
      }
      @if (control.errors['ngbDate']?.['invalid']) {
        <span>
          {{ ('invalid_input' | translate: label) + '.' }}
        </span>
      }
      @if (control.errors['ngbDate']?.['minDate'] && errors['min_date']) {
        <span> {{ errors['min_date'] }}. </span>
      }
      @if (!control.errors['ngbDate']?.['invalid'] && control.errors['pattern']) {
        <span>
          {{ 'invalid_date_format_input' | translate: 'MM/DD/YYYY' }}
        </span>
      }
      @if (control.errors['_error']) {
        <span>
          <ul class="m-0 p-0 list-unstyled">
            @for (error of control.errors['_error']; track error) {
              <li class="fw-light">{{ error }}</li>
            }
          </ul>
        </span>
      }
    </div>
  }

  @if (help_text) {
    <div id="{{ id }}-help" class="form-text">
      {{ help_text }}
    </div>
  }
</div>
